export default __webpack_public_path__ + "static/media/twitterBlack.452a4498.svg";